var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"container text-center mt-4"},[_c('b-alert',{staticClass:"text-light mt-4 mb-4",staticStyle:{"background-color":"rgb(93, 93, 97, 0.5)"},attrs:{"variant":"outline-primary","fade":"","show":_vm.systemAlert}},[_vm._v(_vm._s(_vm.systemAlertMessage))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }